(ns bleene.layout.events
  (:require [minorodata.app.utils :as app.utils]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]))


(re-frame/reg-event-db
 :layout/toggle-sidebar
 (fn [db _]
   (let [active? (= (get db :active-pane) :sidebar)]
     (cond-> db
             active? (assoc :active-pane :main-pane)
             :always (update-in [:panes :sidebar :visible?] not)))))


(def directions-map
  {:next inc
   :prev dec})


(defn select-next-item [items item direction]
  (let [pane-index      (.indexOf items item)
        direction-fn    (get directions-map direction)
        next-item-index (mod (direction-fn pane-index)
                             (count items))]
    (nth items next-item-index)))


(re-frame/reg-event-db
 :layout/focus-pane
 (fn [db [_ direction]]
   (let [page-panes    (get-in db [:page :panes])
         visible-panes (filter (fn [pane]
                                 (get-in db [:panes pane :visible?]))
                               page-panes)
         active-pane   (get db :active-pane)
         next-pane     (select-next-item visible-panes active-pane direction)]
     (assoc db :active-pane next-pane))))


(re-frame/reg-event-db
 :layout/set-active-tab
 (fn [db [_ pane-id tab-id]]
   (update-in db [:panes pane-id] assoc :active-tab tab-id)))


(re-frame/reg-event-fx
 :layout/add-new-tab
 (fn [{:keys [db]} [_ pane-id tab-id skip-adding? skip-creating-dag?]]
   (let [tabs (:tabs db)

         active-tab (get-in db [:panes pane-id :active-tab])

         tab-id  (or tab-id
                     (-> (random-uuid)
                         str))

         new-tab {:id   tab-id
                  :name (str "All nodes")
                  :type :dag}]

     {:fx [(when-not skip-creating-dag?
             [:dispatch [:dag/create-new-dag tab-id]])

           [:dispatch-later [(when-not skip-creating-dag?
                               {:ms 10 :dispatch [:dag/clear-filter tab-id]})
                             {:ms 100 :dispatch [:dag/full-layout tab-id]}]]]
      :db       (-> db
                    (update :tabs assoc tab-id new-tab)
                    (assoc-in [:dag tab-id :show-sources?] @(re-posh/subscribe [:unleash/is-enabled "fe.manual-dag-layout"]))
                    (update-in [:panes pane-id] assoc :active-tab (if skip-adding?
                                                                    active-tab
                                                                    tab-id))
                    (update-in [:panes pane-id :tabs] conj tab-id))})))


(re-frame/reg-event-fx
 :layout/close-tab
 (fn [{:keys [db]} [_ pane-id tab-id]]
   (let [tabs           (:tabs db)

         tabs       (get-in db [:panes pane-id :tabs])
         active-tab (get-in db [:panes pane-id :active-tab])
         active?    (= active-tab tab-id)

         tabs' (app.utils/remove-elem tabs tab-id)

         new-active-tab (first tabs')]

     {:fx (cond-> [[:dispatch [:dag/full-layout (if (= new-active-tab "default-dag")
                                                  :default-dag new-active-tab)]]]
            active? (concat [[:dispatch [:layout/set-active-tab pane-id new-active-tab]]]))
      :db (-> db
              (assoc-in [:panes pane-id :tabs] tabs'))})))


(re-frame/reg-event-db
 :layout/focus-tab
 (fn [db [_ pane-id direction]]
   (let [pane-tabs  (get-in db [:panes pane-id :tabs])
         active-tab (get-in db [:panes pane-id :active-tab])
         next-tab   (select-next-item pane-tabs active-tab direction)]
     (update-in db [:panes pane-id] assoc :active-tab next-tab))))


(re-frame/reg-event-db
 :layout/close-dialog
 (fn [db _]
   (update db :dialog assoc :open? false :context nil)))


(re-frame/reg-event-db
 :layout/open-dialog
 (fn [db [_ context-type params]]
   (update db :dialog assoc :open? true
           :context context-type
           :params params)))
